import styled from 'styled-components';

// Styled components for Stack
var Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__Root",
  componentId: "sc-1xurk3-0"
})(["box-sizing:border-box;display:", ";flex-direction:", ";align-items:", ";justify-content:", ";flex-wrap:", ";gap:", ";column-gap:", ";row-gap:", ";margin:0;"], function (_ref) {
  var display = _ref.display;
  return display;
}, function (_ref2) {
  var direction = _ref2.direction;
  return direction;
}, function (_ref3) {
  var align = _ref3.align;
  return align;
}, function (_ref4) {
  var justify = _ref4.justify;
  return justify;
}, function (_ref5) {
  var $wrap = _ref5.$wrap;
  return $wrap;
}, function (_ref6) {
  var gap = _ref6.gap;
  return gap;
}, function (_ref7) {
  var gapX = _ref7.gapX;
  return gapX;
}, function (_ref8) {
  var gapY = _ref8.gapY;
  return gapY;
});
process.env.NODE_ENV !== "production" ? Root.displayName = 'Root' : void 0;

export { Root };
